const Urls = {
  // baseUrl: 'https://entry.alsensorfox.com',
  //baseUrl: 'https://pocportal.alsensorfox.com:5000',
  //baseUrl: 'https://pocportal.alsensorfox.com',
  //baseUrl: 'https://test.iotalinco.com',
  //baseUrl: 'http://192.168.1.9:5001',
  baseUrl: 'https://pocportal.airincomlite.com',
  // baseUrl: 'https://pocportaldev.airincomlite.com',
  privacyUrl: 'http://localhost:3000/privacy',
  //privacyUrl:'https://console.airincomlite.com/privacy',

  account: {
    login: '/authenticate',
    logout: '/logout',
    resetpassword: '/resetpassword',
    resetpasswordotp: '/resetpasswordotp',
    signup: '/signup',
    signupresendotp: '/signupresendotp',
    signupvalidateotp: '/signupvalidateotp',
    updateinfo: '/updateinfo',
    authlog: '/authlog/getall',
    maillog: '/maillog/getall',
    calllog: '/calllog/getall',
    channellog: '/calllog/getallgrouplogs'
  },
  admin: {
    account: '/account',
    list: '/account/getallacount',
    summary: '/totalinfo',
    ban: '/account/ban',
    customerid: '/account/customerid',
    delete: '/account'
  },
  appuser: {
    user: '/user',
    multiuser: '/multiuser',
    list: '/user/getall',
    childlist: '/user/getuserbyaccount',
  },
  appchannel: {
    channel: '/channel',
    multichannel: '/multichannel',
    list: '/channel/getall',
    childlist: '/channel/getchannelbyaccount',
  },
  pocmap: {
    user: '/pocmap/account',
    channel: '/pocmap/group',
  },
  pocaccount: {
    list: '/pocaccount/getall',
    account: '/pocaccount/getbyid',
    update: '/pocaccount/update',
    add: '/pocaccount/register',
    userlist: '/pocaccount/getbyparent',
    status: '/pocaccount/updatestatus',
    member: '/pocaccount/getbychannel',
    coupon: '/pocaccount/coupon',
    getcoupon: '/pocaccount/getcoupon',
    delete: '/pocaccount/delete',
    trial: '/pocaccount/updateremainingtime',
  },
  pocchannel: {
    list: '/pocgroup/getall',
    channel: '/pocgroup/getbyid',
    update: '/pocgroup/update',
    add: '/pocgroup/register',
    userlist: '/pocgroup/getpocgroupbyparent',
    status: '/pocgroup/updategroupstatus',
    member: '/pocgroup/addmember',
    membermulti: '/pocgroup/addmultimember',
    channelmulti: '/pocgroup/addmembertomultigroup',
    channellist: '/pocgroup/getbypocaccount',
    host: '/pocgroup/getgroupadmin',
    delete: '/pocgroup/delete'
  },
  coupon: {
    apply: '/sendcoupon',
  },
  register: {
    apply: '/sendinvoice',
  },
  payment: {
    invoice: '/payment/sendinvoice',
  },
  servicecode: {
    list: '/servicecode/getall',
    addcode: '/servicecode',
    delete: '/servicecode',
    user: '/servicecode/getallbyuser',
    config: '/servicecode/config',
    active: '/servicecode/active',
    info: '/servicecode/activated',
    assign: '/servicecode/assigned',
		newcode: '/servicecode/newcode',
		device: '/servicecode/device/getall'
  },
  serverlogs: {
    list: '/serverlog/getall',
    getfilename: '/serverlog/getfile'
  },
  fincode: {
    redirect: 'fincode/redirect',
    user: '/fincode/getallorderbyaccount',
    list: '/fincode/getallorder',
    orderdetail: '/fincode/orderdetails',
    order: '/fincode/order'
  },

  user: {
    login: '/Accounts/authenticate',
    list: '/Accounts/getall',
    update: '/Accounts',
    childList: '/Accounts/getallchildrenforparent',
    childList2: '/Accounts/getallchildrenforparentassigndevice',
    parentList: '/Accounts/getallparents',
    authLog: '/AuthenticationLogs/getauthenticationlogs',
    changePassword: '/Accounts/resetpassword',
    getMailFromLoginID: '/Accounts/getaccountemailresetpassword',
    checkEmailAndLoginID: '/Accounts/forgetpassword',
    confirmActiveCode: '/Accounts/confirmactivationcoderesetpassword',
    confirmActiveCodeAndSetNewPassword:
      '/Accounts/confirmactivationcoderesetpassword',
  },
  contract: {
    list: '/Contracts/getall',
    listOfAccount: '/Contracts/getcontractsbyaccount',
    link: '/Contracts/linkcontracttoaccount',
    unlink: '/Contracts/unlinkcontractfromaccount',
    update: '/Contracts',
  },
  device: {
    list: '/Devices/getall',
    listOfAccountContract:
      '/Devices/getassigneddevicesbelongcontractsbyaccount',
    listOfMe: '/Devices/getassigneddevicesforcurrentaccount',
    listOfAccount: '/Devices/getassigneddevicesbyaccount',
    listOfContract: '/Devices/getassigneddevicesbycontract',
    listStatusOfAccount: '/DeviceLog/getalllatestlogbyaccount',
    listOrphans: '/Devices/getallorphandevices',
    listOrphansOfAccount:
      '/Devices/getallorphandevicesforcontractbyparentaccount',
    update: '/Devices',
    info: '/Devices',
    assignToAccount: '/Devices/assigndevicestoaccount',
    unassignToAccount: '/Devices/unassigndevicesinaccount',
    assignToContract: '/Devices/assigndevicestocontract',
    advancedLog: '/DeviceLog/getadvancedlog',
    bidirLog: '/DeviceLog/getbidirlog',
    uplinkLog: '/DeviceLog/getuplinklog',
    activities: '/DeviceLog/getdeviceactivities',
    journey: '/DeviceLog/getdevicejourney',
    payload: '/DeviceLog/getdevicepayload',
    payloadExport: '/DeviceLog/exportdevicepayload',
    listOfDevicesContract:
      '/DeviceLog/getassigneddevicesbelongcontractsbyaccount',
    activeAlert: '/Alerts/getactivealerts',
    alertHistory: '/Alerts/getalerthistory',
    listOrphansOfContractByAccount:
      '/Devices/getorphandevicesbelongcontractsbyaccount',
    listAdvancedLog: '/DeviceLog/getalldeviceandlasteddata',
    latestDeviceData: '/DeviceLog/getlatestlog',
    deleteDeviceData: '/DeviceLog/deletedevicedata',
  },
  notify: {
    getNotifyConfiguration: '/NotifyConfiguration/getdevicenotifyconfiguration',
    setNotifyConfiguration:
      '/NotifyConfiguration/storedevicenotifyconfiguration',
    getThresholdValue: '/NotifyConfiguration/getdevicenotifythreshold',
  },
  gpsNotifyConfiguration: {
    getAllGPSSetting: '/GPSConfiguration/getallgpssetting',
    storeGPSSetting: '/GPSConfiguration/addgpssetting',
    editGPSSetting: '/GPSConfiguration/editgpssetting',
    deleteGPSSetting: '/GPSConfiguration/deletegpssetting',
    storeGPSMailSetting: '/GPSConfiguration/storegpsconfiguration',
    getGPSMailSetting: '/GPSConfiguration/getgpsconfiguration',
  },
  image: {
    getImagesDevice: '/Image/deviceimage',
    uploadImage: '/Image/upload',
    deleteImage: '/Image',
    deleteDeviceImage: '/Image/deleteimagesbelongdevice',
  },
  xe1151: {
    getImageCoordinatesByDevice:
      '/Xe1151DeviceCoordinates/getimagecoodinatesbydevice',
    getAllImageCoordinates: '/Xe1151DeviceCoordinates/getallimagecoodinates',
    setImageCoordinatesByDevice:
      '/Xe1151DeviceCoordinates/setdevicecoordinates',
    updateDeviceCoordinates: '/Xe1151DeviceCoordinates/updatedevicecoordinates',
    deleteDeviceCoordinates: '/Xe1151DeviceCoordinates/deletedevicecoordinates',
  },
  sf03wt2: {
    storeDeviceNotifyConfiguration:
      '/SF03Configuration/storedevicenotifyconfiguration',
    getDeviceNotifyConfiguration:
      '/SF03Configuration/getdevicenotifyconfiguration',
  },
  sf07: {
    storeDeviceNotifyConfiguration:
      '/DKSF07Configuration/storedevicenotifyconfiguration',
    getDeviceNotifyConfiguration:
      '/DKSF07Configuration/getdevicenotifyconfiguration',
  },
};
export default Urls;
